import PropTypes from 'prop-types';
import React from 'react';
import {Button, Col, Form, Row} from 'react-bootstrap';
import _ from 'lodash';
import translate from '../translate';

class EditLargeCard extends React.Component {
    static propTypes = {
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        children: PropTypes.node.isRequired,
        submitLabel: PropTypes.string,
        active_on_init: PropTypes.bool,
        optional: PropTypes.string,
        description: PropTypes.string,
        handleSubmit: PropTypes.func.isRequired,
        validationEnabled: PropTypes.bool,
        strings: PropTypes.object,
        error: PropTypes.bool,
        errorElement: PropTypes.element,
        handleCancel: PropTypes.func,
        footnote: PropTypes.string,
        disabled: PropTypes.bool,
    };

    static defaultProps = {
        active_on_init: false,
        title: 'Title',
        description: '',
        optional: null,
        error: false,
        disabled: false,
        handleCancel: () => {},
    };

    state = {
        active: this.props.error || this.props.active_on_init,
        submitTried: this.props.error,
        formState: { _valid: false },
    };

    _handleFormChange = (formState, index) => {
        this.setState({ formState });

        const child = this.props.children[index] || this.props.children;
        if (
            child &&
            child.props &&
            typeof child.props.handleChange === 'function'
        ) {
            child.props.handleChange(formState);
        }
    };

    _toggleForm = (submit) => {
        if (this.state.active && !submit) {
            this.props.handleCancel();
        }
        this.setState({ active: !this.state.active, submitTried: submit });
    };

    _handleSubmit = (event) => {
        event.preventDefault();
        const formState = _.extend({}, this.state.formState);
        if (formState._valid) {
            this.props.handleSubmit(formState);
            this._toggleForm(true);
        }
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.error !== this.props.error && nextProps.error) {
            this.setState({ active: true });
        }
    }

    render() {
        const optional = this.props.optional ? (
            <small>{this.props.optional}</small>
        ) : null;
        const title = _.isString(this.props.title)
            ? this.props.title
            : [this.props.title[0], <span key={1}>{this.props.title[1]}</span>];
        const divider = _.isString(this.props.title) ? (
            <hr className="divider" />
        ) : null;
        const active = this.state.active;
        const showErrorElement =
            active &&
            this.state.submitTried &&
            this.props.error &&
            !!this.props.errorElement;
        return (
            <Row>
                <Col xs={12} sm={12} md={12} lg={12}>
                    <div
                        className={
                            'card level-1 clickbox' +
                            (active ? ' card-edit' : '')
                        }
                    >
                        <div className="card-content">
                            <div className="card-desc">
                                <h3 className="headline1">
                                    {' '}
                                    {title} {optional}{' '}
                                </h3>
                                {divider}
                                {this.props.description}
                            </div>
                            <Form onSubmit={this._handleSubmit}>
                                {React.Children.map(
                                    this.props.children,
                                    (child, index) =>
                                        child &&
                                        React.cloneElement(child, {
                                            handleChange: (formState) =>
                                                this._handleFormChange(
                                                    formState,
                                                    index
                                                ),
                                            disabled:
                                                !active || this.props.disabled,
                                            toggleForm: this._toggleForm,
                                            error: this.props.error,
                                        })
                                )}
                                <div className="clearfix"></div>
                                {!this.props.disabled && (
                                    <div className="form-footer">
                                        {showErrorElement && (
                                            <div className="mb-2">
                                                {this.props.errorElement}
                                            </div>
                                        )}
                                        <Button
                                            onClick={() =>
                                                this._toggleForm(false)
                                            }
                                            className={
                                                'btn btn-link btn-action' +
                                                (active
                                                    ? ' btn-close'
                                                    : ' btn-edit')
                                            }
                                        >
                                            {active
                                                ? this.props.strings.cancel
                                                : this.props.strings.edit}
                                        </Button>
                                        <Button
                                            type="submit"
                                            disabled={
                                                this.props.validationEnabled &&
                                                !this.state.formState._valid
                                            }
                                            className={
                                                'btn btn-primary pull-right' +
                                                (active ? '' : ' hidden')
                                            }
                                        >
                                            {this.props.submitLabel ||
                                                this.props.strings.save}
                                        </Button>
                                    </div>
                                )}
                                {this.props.footnote && (
                                    <div className="form-footnote">
                                        {this.props.footnote}
                                    </div>
                                )}
                            </Form>
                        </div>
                    </div>
                </Col>
            </Row>
        );
    }
}

export default translate('General')(EditLargeCard);
